const values = {
  PDF: "pdf",
  OUTPUT: "output",
  TEMPLATE: "template",
  PREVIOUS: "Previous",
  SAVE: "Save",
  GRANT: "Grant Access",
  PROJECT_NAME: "Product/Project Name",
  DRUG_TYPE: "Drug Type",
  UPLOAD_SAMPLE_BATCH_RECORD: "Select Master Batch Record",
  DATA_PARAMETER: "Select Input Schema",
  DATA_FORMAT: "Select Output Schema",
  PROJECT_HEADER: "Projects (Drug Products)",
  CREATE_BATCH: "Create Batch",
  BATCH_NAME: "Batch Name",
  TEXT_EXTRACTION: "Auto text extraction",
  TEXT_EXTRACT: "Auto text extract",

  SELECT: "Select user",
  TIMELINE: "Assign a Timeline",
  SUBJECT: "Subject",
  ASSIGN: "Assign User",
  SUBMIT_PROCESSING: "Submit For Processing",
  SUBMIT_VALIDATION: "Submit For Validation",
  PRE_NAME: "Pre Processor",
  PRO_NAME: "Processor",
  VAL_NAME: "Validator",
  STATUS: "Status",
  BATCH_DETAILS: "Batch Details",
  COUNT: "Count",
  PDFS: "PDF(s)",
  ASSIGNED: "Assigned To",
  OCR_STATUS: "Extraction Status",
  LAST_UPDATED: "Last Updated",
  ACTION: "Action",
  END_DATE: "End Date",
  DOCUMENT_DETAIL: "Document Detail",
  DATA: "Data",
  PARAMETER_NAME: "Parameter Name",
  VALUE: "Value",
  PDF_NAME: "Pdf Name",
  OUT_OF_RANGE: "Out of Range",
  PAGE_NO: "Page No.",
  EXTRACTION_DETAILS: "Extraction Details",
  HISTORY: "History Data",
  UPDATED_ON: "Updated On(GMT)",
  PROJECT_NAME_ONLY: "Project Name",
  FILE_NAME: "File Name",
  FILE_TYPE: "File Type",
  PREVIEW: "Preview",
  PRODUCT_NAME: "Product Name",
  TEMPLATE_NAME: "Template Name",
  QC_TEMPLATE: "Import QC Template",
  SELECT_EXTRACTION_USER: "Select User For Extraction ",
  SELECT_QC_USER: "Select User For QC ",
  SELECT_EXTRACTION_TIMELINE: "Select Timeline For Extraction ",
  SELECT_QC_TIMELINE: "Select Timeline For QC ",
  ADMIN: "Admin",
  REVIEW_STATUS: "Review Status",
  SUBMIT_MAPPING_APPRVAL: "Submit For Mapping Approval",
  SUBMIT_VALIDATION_REVIEW: "New batch assigned for Review",
};

export default Object.freeze(values);
